<template>
  <TabPanel class="tw-w-full">
    <div class="tw-grid tw-grid-cols-12 tw-gap-5">
      <template v-for="item in items" :key="item.id">
        <div class="tw-col-span-full md:tw-col-span-4">
          <Button
            color="semiTransparentWhite"
            class="tw-w-full tw-justify-center md:tw-whitespace-nowrap"
            :loading="loadingIds.has(item.id)"
            :disabled="loadingIds.has(item.id)"
            @click="restart(item)"
          >
            {{ item.label }}
          </Button>
        </div>

        <div class="tw-col-span-full md:tw-col-span-8 tw-flex tw-flex-col tw-justify-center tw-gap-1">
          <Text>{{ item.description }}</Text>

          <Text v-if="item.warning" class="tw-font-black tw-text-orange">{{ item.warning }}</Text>
        </div>
      </template>
    </div>
  </TabPanel>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { computed, ref, watch } from 'vue';

import { Button, TabPanel, Text } from '@slideslive/fuse-kit/vue';

import fetcher from '@/fetcher';
import useStateStore from '@/stores/state';

const { state } = storeToRefs(useStateStore());

const items = computed(() => state.value?.data?.restart_targets?.items || []);

const loadingIds = ref(new Set());
const sawRestartIds = ref(new Set());

const nateStatus = computed(() => state.value?.data?.nate?.status || '');

watch(nateStatus, (s) => {
  if (!loadingIds.value.size) return;

  if (s !== 'running') {
    loadingIds.value.forEach((id) => sawRestartIds.value.add(id));
  }

  if (s === 'running') {
    sawRestartIds.value.forEach((id) => loadingIds.value.delete(id));
    sawRestartIds.value.clear();
    loadingIds.value = new Set(loadingIds.value);
  }
});

const restart = async (item) => {
  if (item?.confirm) {
    const ok = window.confirm([item.description, item.warning].filter(Boolean).join('\n\n'));
    if (!ok) return;
  }

  loadingIds.value = new Set([...loadingIds.value, item.id]);
  sawRestartIds.value.delete(item.id);

  try {
    await fetcher.post('/system/-/restart', { id: item.id });
  } catch {
    loadingIds.value.delete(item.id);
    loadingIds.value = new Set(loadingIds.value);
    sawRestartIds.value.delete(item.id);
  }
};
</script>
